import { getData, deleteData, postData, putData } from '../apiClient';

export const getFloorAssignWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/floor-assign/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Floor Assign with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

export const getAllFloors = async () => {
    try {
        const result = await getData(`/floor-assign/get-floors`);
        return {
            success: true,
            data: result,
        };
    } catch (error) {
        console.error("Get All Floors API error:", error.status === 400 ? error.error : error.message);
        return {
            success: false,
            ...error,
        };
    }
};

export const createFloorAssign = async ({ data }) => {
    try {
        const result = await postData(`/floor-assign/create-assign`, data,);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create Floor Assign API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

export const getFloorAssignById = async (id) => {
    try {
        const result = await getData(`/floor-assign/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Floor Assign data API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

export const updateFloorAssign = async ({ id, data }) => {
    try {
        const result = await putData(`/floor-assign/update-assign/${id}`, data,);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update Floor Assign API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

export const deleteFloorAssign = async ({ id }) => {
    try {
        const result = await deleteData(`/floor-assign/delete-assign/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                status: result.status
            }
        };
    } catch (error) {
        console.error('Delete floor assign API error:', error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            }
        };
    }
};